import { render, staticRenderFns } from "./advList.vue?vue&type=template&id=96fb999c&scoped=true&"
import script from "./advList.vue?vue&type=script&lang=js&"
export * from "./advList.vue?vue&type=script&lang=js&"
import style0 from "./advList.vue?vue&type=style&index=0&id=96fb999c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96fb999c",
  null
  
)

export default component.exports